module.exports = __webpack_public_path__ + "img/pc8.549e6b13.png";